var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row timeline" },
    [
      _c(
        "q-timeline",
        { ref: "timeLine", attrs: { responsive: "", color: "secondary" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.itensConvertidos != null &&
                    _vm.itensConvertidos != undefined &&
                    _vm.itensConvertidos != "",
                  expression:
                    "itensConvertidos != null && itensConvertidos != undefined && itensConvertidos != ''"
                }
              ],
              staticClass: "timeline-titulo"
            },
            [_vm._v("\n      " + _vm._s(_vm.titulo) + "\n    ")]
          ),
          _c(
            "div",
            _vm._l(_vm.itensConvertidos, function(i) {
              return _c(
                "q-timeline-entry",
                {
                  key: i.a,
                  class: _vm.setCorpo(_vm.setSide(i.sequencia)),
                  attrs: {
                    side: _vm.setSide(i.sequencia),
                    icon: _vm.icone,
                    subtitle: i.sequencia,
                    color: _vm.setCor(_vm.setSide(i.sequencia))
                  }
                },
                _vm._l(i.arrayConteudo, function(c) {
                  return _c("div", { key: c.a }, [
                    c.negrito
                      ? _c("strong", [
                          _vm._v(
                            "\n            " +
                              _vm._s(c.conteudo) +
                              "\n          "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(c.conteudo) +
                              "\n          "
                          )
                        ])
                  ])
                })
              )
            })
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }